import { render, staticRenderFns } from "./cCarrusel.vue?vue&type=template&id=16ea3b35"
import script from "./cCarrusel.vue?vue&type=script&lang=js"
export * from "./cCarrusel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports